module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kiwi-channelinfo"
  }, [_c('form', {
    staticClass: "u-form kiwi-channelinfo-basicmodes",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('label', {
    staticClass: "kiwi-channelinfo-topic"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('channel_topic'))), _c('br'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.topic),
      expression: "topic",
      modifiers: {
        "lazy": true
      }
    }],
    attrs: {
      "rows": "2"
    },
    domProps: {
      "value": (_vm.topic)
    },
    on: {
      "change": function($event) {
        _vm.topic = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modeM),
      expression: "modeM"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.modeM) ? _vm._i(_vm.modeM, null) > -1 : (_vm.modeM)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.modeM,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.modeM = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.modeM = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.modeM = $$c
        }
      }
    }
  }), _vm._v("\n            " + _vm._s(_vm.$t('channel_moderated')) + "\n        ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modeI),
      expression: "modeI"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.modeI) ? _vm._i(_vm.modeI, null) > -1 : (_vm.modeI)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.modeI,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.modeI = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.modeI = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.modeI = $$c
        }
      }
    }
  }), _vm._v("\n            " + _vm._s(_vm.$t('channel_invite')) + "\n        ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modeT),
      expression: "modeT"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.modeT) ? _vm._i(_vm.modeT, null) > -1 : (_vm.modeT)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.modeT,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.modeT = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.modeT = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.modeT = $$c
        }
      }
    }
  }), _vm._v("\n            " + _vm._s(_vm.$t('channel_moderated_topic')) + "\n        ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modeN),
      expression: "modeN"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.modeN) ? _vm._i(_vm.modeN, null) > -1 : (_vm.modeN)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.modeN,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.modeN = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.modeN = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.modeN = $$c
        }
      }
    }
  }), _vm._v("\n            " + _vm._s(_vm.$t('channel_external')) + "\n        ")]), _vm._v(" "), _c('label', [_vm._v("\n            " + _vm._s(_vm.$t('password'))), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.modeK),
      expression: "modeK",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "u-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.modeK)
    },
    on: {
      "change": function($event) {
        _vm.modeK = $event.target.value
      }
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-56a8a4d6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChannelInfo.vue
// module id = 489
// module chunks = 2